


































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import EventBus from '../../services/eventbus.service';

@Component({
  components: {
  },
})

export default class SettingsWidget extends Vue {
  @Prop() private data!: any;
  @Prop() private bus!: any;
  private toggled: any[] = [];
  private selectedProjects: any[] = [];
  private selectedOrgs: any[] = [];
  private selectedOrg: any = {};
  private chartTypes: string[] = [ 'line', 'area' ];
  private groupBy: string = 'none';
  private groupByOptions: string[] = [ 'deviceId', 'location', 'none' ];

  private chartType: string = '';
  private tableData: any[] = [];
  private events: any[] = [];
  private alertData: any[] = [];


  private mounted() {
    if (this.data.source === 'table' || this.data.source === 'events') {
      Vue.set(this, 'tableData', this.data.payload.headers);
      this.setTableColumns(this.tableData);
    }

    if (this.data.source === 'events') {
      Vue.set(this, 'events', this.data.payload.values.events);
      if (this.data.config) {
        Vue.set(this, 'selectedProjects', this.data.config.projectFilters);
        Vue.set(this, 'selectedOrgs', this.data.config.organisationFilters);
      }
    }

    if ( this.data.source === 'chart' ) {
      if ( this.data.config && this.data.config.length !== 0 ) {
        this.selectedOrg = this.data.config.measurementsSelectedOrg;
        this.chartType = this.data.config.chartType;
        this.groupBy = this.data.config.measurementsGroupBy;
      } else {
        this.selectedOrg = this.data.payload.values[0];
        this.chartType = this.chartTypes[0];
        this.data.config = {};
        this.selectMeasurementsOrganisation( this.selectedOrg.slug );
        this.selectChartType( this.chartType );
      }
    }
}

  private filterColumns(col: string) {
    // TODO
  }

  private toggleColumns(col: any, toggled: string[], source: string, title: string, id: string) {
    EventBus.$emit('toggleCols', col, toggled, source, title, id);
  }
  private selectProjects() {
    this.data.config.projectFilters = this.selectedProjects;

    if (this.selectedProjects && this.selectedProjects.length) {
      EventBus.$emit('selectEventsProjects', this.events, this.selectedProjects);
    } else {
      Vue.set(this, 'events', this.data.payload.values.events);
    }
  }
  private selectOrganisation() {
    this.data.config.organisationFilters =  this.selectedOrgs;

    if (this.selectedOrgs && this.selectedOrgs.length) {
      EventBus.$emit('selectEventsOrganisation', this.events, this.selectedOrgs);
    } else {
      Vue.set(this, 'events', this.data.payload.values.events);
    }
  }

  private get projectFilters() {
    if (this.selectedOrgs && this.selectedOrgs.length) { // Projects filter out non-specific orgs
      return this.events.filter((p: any) => this.selectedOrgs.some((org: string) => p.name === org));
    } else {
      Vue.set(this, 'events', this.data.payload.values.events);
      EventBus.$emit('selectEventsProjects', this.events, this.selectedProjects);
      return this.events;
    }
  }
  private get orgFilters() {
    if (this.selectedProjects && this.selectedProjects.length) { // Orgs filter out non-specific projects
      return this.events.filter((p: any) => this.selectedProjects.some((org: string) => p.projectName === org));
    } else {
      Vue.set(this, 'events', this.data.payload.values.events);
      EventBus.$emit('selectEventsOrganisation', this.events, this.selectedOrgs);
      return this.events;
    }
  }

  private clearSelected(source: string) {
    if (source === 'org') { this.selectedOrgs = []; }
    if (source === 'project') { this.selectedProjects = []; }
    if (!this.selectedProjects.length && !this.selectedOrgs.length) {
      Vue.set(this, 'events', this.data.payload.values.events);
    }
  }

  private selectMeasurementsOrganisation(org: string) {
    this.data.config.measurementsSelectedOrg = this.selectedOrg;
    EventBus.$emit('selectMeasurementsOrganisation', org);
  }

  private selectChartType(chartType: string) {
    this.data.config.chartType = this.chartType;
    EventBus.$emit('selectChartType', chartType);
  }

  private selectGroupBy( groupBy: string ) {
    if ( this.groupBy === 'none' ) {
      this.groupBy = '';
    }
    this.data.config.measurementsGroupBy = this.groupBy;
    EventBus.$emit( 'selectGroupBy', groupBy );
  }

  private setTableColumns(data: any[]) {
    const cols: any[] = [];
    for (const header of data) {
      if (this.data.enabledFields.includes(header.value)) {
        cols.push(header.value);
      }
    }
    Vue.set(this, 'toggled', cols);
    EventBus.$emit('defaultColsSet', this.toggled);
    EventBus.$emit('alertColsSet', this.toggled);

  }
}
